import React from "react";
import { Button } from "react-bootstrap";

const FormSpinner = props => {
  var className = "order-unit-form-spinner";
  if (props.compact) {
    className += " order-unit-form-spinner-compact";
  }

  return (
    <span className={className}>
      <i className="fa fa-spinner fa-spin" />
    </span>
  );
};

export default class OrderUnitProductInfo extends React.Component {
  remove(event) {
    event.preventDefault();

    this.props.removeFn(this.props.orderUnit, this.props.product.id);
  }

  update(event) {
    event.preventDefault();

    if (this.productCount.value) {
      if (parseInt(this.productCount.value, 10) <= 0) {
        this.productCount.value = 1;
      }

      this.props.updateFn(
        this.props.orderUnit,
        this.props.product.id,
        this.productCount.value,
      );
    }
  }

  render() {
    const { orderUnitProduct, product, isSubmitting, isEditable } = this.props;

    return (
      <div>
        <p
          className="order-unit-heading"
          id={`order-unit-product-info-product-${orderUnitProduct.productId}`}
        >
          {isEditable ? (
            <input
              type="number"
              required
              className="order-unit-edit-count"
              ref={input => {
                this.productCount = input;
              }}
              min="1"
              step="1"
              defaultValue={orderUnitProduct.productCount}
              placeholder="Anzahl"
              onChange={this.update.bind(this)}
            />
          ) : (
            `${orderUnitProduct.productCount}`
          )}
          ×{` ${product.productVariantName}`}
          {isEditable && !isSubmitting && (
            <Button onClick={this.remove.bind(this)}>Entfernen</Button>
          )}
          {isSubmitting && <FormSpinner compact />}
        </p>
        {product.images[0] && (
          <div className="order-unit-image">
            <img src={product.images[0].high} alt={`${product.name}`} />
          </div>
        )}
      </div>
    );
  }
}
